
    import './styles.scoped.css';
    export default {
  "close-button": "awsui_close-button_16w0h_4ncpq_3",
  "circular-toggle": "awsui_circular-toggle_16w0h_4ncpq_10",
  "circular-toggle-selected": "awsui_circular-toggle-selected_16w0h_4ncpq_48"
};
  